module.exports = __webpack_public_path__ + "static/media/saile-sun.9d61de1f.png";